import {Check, Link2} from 'lucide-react'
import { useState } from 'react'
import { tokenShareUrl } from '@/lib/shareSlug'

function ShareTokenLink({
  shareSlug,
  fallbackId,
  accent = 'orange',
}: {
  shareSlug?: string
  fallbackId?: string
  accent?: 'orange' | 'lime'
}) {
  const [copied, setCopied] = useState(false)
  const url = tokenShareUrl(shareSlug, fallbackId)
  const color = accent === 'lime'
    ? 'border-lime-400/30 bg-lime-400/10 text-lime-400 hover:border-lime-400/50'
    : 'border-orange-400/30 bg-orange-400/10 text-orange-400 hover:border-orange-400/50'

  async function copy() {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1600)
    }
    catch {
      setCopied(false)
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      aria-label="Copy share link"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${color}`}
    >
      {copied
        ? <Check className="h-3.5 w-3.5" aria-hidden="true" />
        : <Link2 className="h-3.5 w-3.5" aria-hidden="true" />}
      {copied ? 'Copied' : url.replace(/^https?:\/\//, '')}
    </button>
  )
}

export default ShareTokenLink
